import { Identity } from '@equipmentshare/auth0-react';
import { Menu } from './menu';

export enum CustomEventType {
  MENU = 'menu-event',
  AUTH_UPDATED = 'auth-updated',
  AUTH_HELPERS_INITIALIZED = 'auth-helpers-initialized',
}

export interface MenuEvent {
  detail: Menu;
}

export interface AuthEventData {
  isLoading: boolean;
  isAuthenticated: boolean;
  identity: Identity | null;
}
